var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi-item"},[_c('span',{staticClass:"item-title"},[_vm._v("直播场次")]),_c('div',{staticStyle:{"margin":"32px 0 8px"}},[_c('span',{staticClass:"font1"},[_vm._v(_vm._s(12))]),_c('span',{staticClass:"font2"},[_vm._v("/"+_vm._s(12))])]),_c('a-progress',{attrs:{"percent":(12 / 15) * 100,"show-info":false,"strokeColor":"#FFCA5C"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }